"use client";

import { c as _c } from "react/compiler-runtime";
import { FlexCenter, FlexColumn, TextHeading } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { Sound, usePlaySound } from "@/hooks/use-play-sound";
import { OnboardingButton } from "../components/OnboardingButton";
import { onboardingSteps } from "../Onboarding";
import { IntroStepLogo } from "./intro/IntroStepLogo";
import { StepContainer } from "./Step";
export function IntroComponent(t0) {
  const $ = _c(15);
  const {
    heading,
    watchFilmLabel,
    getStartedLabel,
    onClickWatchFilm,
    onClickGetStarted
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IntroStepLogo />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== heading) {
    t2 = <FlexColumn className="items-center gap-4">{t1}<TextHeading className="text-center" size="md">{heading}</TextHeading></FlexColumn>;
    $[1] = heading;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onClickWatchFilm || $[4] !== watchFilmLabel) {
    t3 = <OnboardingButton onClick={onClickWatchFilm}>{watchFilmLabel}</OnboardingButton>;
    $[3] = onClickWatchFilm;
    $[4] = watchFilmLabel;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== getStartedLabel || $[7] !== onClickGetStarted) {
    t4 = <OnboardingButton onClick={onClickGetStarted} variant="primary">{getStartedLabel}</OnboardingButton>;
    $[6] = getStartedLabel;
    $[7] = onClickGetStarted;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <FlexCenter className="gap-4">{t3}{t4}</FlexCenter>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t5) {
    t6 = <FlexColumn className="items-center gap-6 px-6 md:px-0">{t2}{t5}</FlexColumn>;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
export function IntroStep(props) {
  const $ = _c(20);
  const t = useTranslations("IntroStep");
  const [playOnboardWelcome] = usePlaySound(Sound.OnboardWelcome);
  let t0;
  if ($[0] !== t) {
    t0 = t("getStarted");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("heading");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== playOnboardWelcome || $[5] !== props) {
    t2 = () => {
      props.goToStep(onboardingSteps.indexOf("persona"));
      playOnboardWelcome();
    };
    $[4] = playOnboardWelcome;
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props) {
    t3 = () => {
      props.onConfirm();
    };
    $[7] = props;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("watchFilm");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t0 || $[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t5 = <IntroComponent getStartedLabel={t0} heading={t1} onClickGetStarted={t2} onClickWatchFilm={t3} watchFilmLabel={t4} />;
    $[11] = t0;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== props || $[18] !== t5) {
    t6 = <StepContainer className="overflow-y-hidden" {...props}>{t5}</StepContainer>;
    $[17] = props;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}